import { Actions } from './index.constants';

export const setTerraApp = isTerraApp => ({
    type: Actions.SET_TERRA_APP,
    isTerraApp,
});
